<router-outlet></router-outlet>
<div *ngIf="isDevMode" class="dev-ribbon" title="Dev mode: using the test collections, not production data">DEV</div>
